'use strict';

function transformDateTimePartNumberToStringWithZeroPadding(dateTimePart, paddingCount = 2) {
  return String(dateTimePart).padStart(paddingCount, "0");
}

module.exports = transformDateTimePartNumberToStringWithZeroPadding;
//# sourceMappingURL=transformDateTimePartNumberToStringWithZeroPadding.cjs.map
